import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class DebriefMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [
        // { name: 'Overview', url: '/debrief/overview' },
        { name: 'Accuracy', url: '/debrief/accuracy', title: 'Accuracy' },
        {
          name: 'Acc. Comp.',
          url: '/debrief/completed-accuracy',
          title: 'Accuracy of Completed Loans',
        },
        { name: 'Progress', url: '/debrief/progress', title: 'Progress' },
        { name: 'Flow Rate', url: '/debrief/flow-rate', title: 'Flow Rate' },
        {
          name: 'P.T.',
          url: '/debrief/processing-time',
          title: 'Processing Time',
        },
        {
          name: 'P.T. Var.',
          url: '/debrief/variation-processing-time',
          title: 'Processing Time Variation',
        },
        {
          name: 'L.C.: Task',
          url: '/debrief/learning-curve',
          title: 'Learning Curve: Task',
        },
        {
          name: 'L.C.: All',
          url: '/debrief/total-learning-curve',
          title: 'Learning Curve: All',
        },
        {
          name: 'Leaderboard',
          url: '/debrief/leaderboard',
          title: 'Leaderboard',
        },
      ],
    };

    // Bindings
  }

  render() {
    const { game, className = '' } = this.props;
    const links = this.state.links.map((l, li) => {
      const active = this.props.location.pathname.includes(l.url)
        ? 'btn-primary'
        : 'btn-link';
      return (
        <Link
          key={'dm-' + li}
          to={`/games/${game.data._id}${l.url}`}
          title={l.title}
          className={`btn ${active} btn-sm ms-3 ${active}`}>
          {l.name}
        </Link>
      );
    });

    return (
      <div className={`debrief-menu ${className}`}>
        {/* Menu links */}
        {links}
        {/* Refresh button */}
        <button
          className='btn btn-sm btn-outline-primary ms-3'
          title='Reload Page'
          aria-label='Reload Page'
          onClick={(e) => window.location.reload()}>
          <FontAwesomeIcon icon='redo-alt' className='me-1' size='sm' />
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { game } = state;
  return {
    game,
  };
}

const connectedPage = connect(mapStateToProps)(DebriefMenu);
export { connectedPage as DebriefMenu };
// export default DebriefMenu
